import React from "react";
import { useTheme } from "@chakra-ui/system";

export default function Loading() {
  const theme = useTheme();

  return (
    <svg viewBox="0 0 245 152" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 37.6c0-8.96 0-13.441 1.744-16.864a16 16 0 0 1 6.992-6.992C24.16 12 28.64 12 37.6 12h169.8c8.961 0 13.441 0 16.864 1.744a16.003 16.003 0 0 1 6.992 6.992C233 24.16 233 28.64 233 37.6v76.8c0 8.961 0 13.441-1.744 16.864a16.005 16.005 0 0 1-6.992 6.992C220.841 140 216.361 140 207.4 140H37.6c-8.96 0-13.441 0-16.864-1.744a16.003 16.003 0 0 1-6.992-6.992C12 127.841 12 123.361 12 114.4V37.6Z"
        fill={theme.colors.integrator[500]}
        data-testid="main-bg"
      />
      <path
        d="M12 37.6c0-8.96 0-13.441 1.744-16.864a16 16 0 0 1 6.992-6.992C24.16 12 28.64 12 37.6 12h169.8c8.961 0 13.441 0 16.864 1.744a16.003 16.003 0 0 1 6.992 6.992C233 24.16 233 28.64 233 37.6v74.8c0 8.961 0 13.441-1.744 16.864a16.005 16.005 0 0 1-6.992 6.992C220.841 138 216.361 138 207.4 138H37.6c-8.96 0-13.441 0-16.864-1.744a16.003 16.003 0 0 1-6.992-6.992C12 125.841 12 121.361 12 112.4V37.6Z"
        fill="#fff"
        fillOpacity={0.24}
      />
      <path
        d="M2 22V6a4 4 0 0 1 4-4h16M223 2h16a4 4 0 0 1 4 4v16M243 130v16a4 4 0 0 1-4 4h-16M22 150H6a4 4 0 0 1-4-4v-16"
        stroke={theme.colors.integrator[500]}
        strokeWidth={3}
        strokeLinecap="round"
      />
    </svg>
  );
}
